export default __webpack_public_path__ + "static/media/wave3.71e289c2.png";